module.exports = __webpack_public_path__ + "static/media/Receipe3.06ae48e6.svg";